import TranslatesExport from "./translates-export";

export default TranslatesExport;